import axios from 'axios';
import { freshAccessToken } from '../auth/accessToken';

// Configure axios baseURL based on environment
// In development: Vite proxy handles /api requests to backend
// In production: Use VITE_API_BASE_URL to call Function App directly
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api'
});

// User ID header will be set after MSAL login in LoginButton.tsx

// Add request interceptor to inject the Authorization header
axiosInstance.interceptors.request.use(
  async (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);

    // A fresh token on every request, as services/ecm-api.ts does (auth/accessToken.ts): the token
    // saved at sign-in expires after about an hour, and a page left open longer then got 401 on
    // every call. Signed out, there is no token and none is asked for.
    const token = await freshAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Also add user info headers if available
    const userStr = sessionStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        config.headers['x-dev-user-id'] = user.email;
        config.headers['x-dev-user-name'] = user.name || user.email;
      } catch (e) {
        console.error('Failed to parse user from sessionStorage');
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    // Suppress 404 noise from non-critical presence endpoints (heartbeat swallowed at call site)
    const url: string = error.config?.url || '';
    if (!(error.response?.status === 404 && url.includes('presence'))) {
      console.error('API Error:', error.response?.status, error.config?.url, error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
